import { ChatWidget } from './components/ChatWidget'
import { ChatWidgetConfig } from './types'

// Global instance
let widgetInstance: ChatWidget | null = null

// Main init function
export function init(config: ChatWidgetConfig): ChatWidget {
  // Destroy existing instance if any
  if (widgetInstance) {
    widgetInstance.destroy()
  }

  // Create new instance
  widgetInstance = new ChatWidget(config)
  return widgetInstance
}

// Destroy function
export function destroy(): void {
  if (widgetInstance) {
    widgetInstance.destroy()
    widgetInstance = null
  }
}

// Get current instance
export function getInstance(): ChatWidget | null {
  return widgetInstance
}

// Browser global API
if (typeof window !== 'undefined') {
  // Check for config in window
  if ((window as any).aiChatbotConfig) {
    init((window as any).aiChatbotConfig)
  }

  // Expose API on window
  (window as any).ConverseaWidget = {
    init,
    destroy,
    getInstance,
  }
}

// Export types and classes for TypeScript users
export { ChatWidget }
export type { ChatWidgetConfig, ChatMessage, WidgetState, WidgetTheme } from './types'

// Default export
export default {
  init,
  destroy,
  getInstance,
}
